import React from 'react'

import { Consumer } from './formProvider'

const Input = props => {
    const {
        name = null,
        className = '',
        value = '',
        type = 'text',
        placeholder = '',
        label = null,
        required = false,
        ...rest
    } = props

    return (
        <Consumer>
            {({ formState, handleChange }) => (
                <React.Fragment>
                    {label ? <label className="required">{label}</label> : null}
                    <input
                        name={name}
                        placeholder={placeholder}
                        className={`input-base ${className} ${
                            required ? 'required' : ''
                        }`}
                        min={0}
                        required={required}
                        type={type}
                        onChange={handleChange(name)}
                        value={formState[name] ? formState[name] : value}
                        {...rest}
                    />
                </React.Fragment>
            )}
        </Consumer>
    )
}

export default Input
